import React from "react";

// assets
import Broadcast from "assets/customSVG/sequence/Broadcast";
import QRCode from "assets/customSVG/sequence/QRCode";
import Whatsapp from "assets/customSVG/Whatsapp";

// helper
import { cn } from "../../../../../helper/cn";
import Meta from "../../../../../assets/customSVG/sequence/Meta";
import WebhookIcon from "../../../../../assets/customSVG/campaigns/WebhookIcon";
import Key from "../../../../../assets/customSVG/Key";
import FollowUpTimer from "../../../../../assets/customSVG/sequence/FollowUpTimer";
import Assignee from "../../../../../assets/customSVG/sequence/actions/Assignee";

// constants
import { ACTIONS_LIST, OPERATIONS_LIST } from "../../../constants/triggers";

const nodeTypes = {
  TEXT: "Text Message",
  MEDIA: "Media Message",
  BUTTON: "Interactive Message",
  LIST: "List Message",
  LOCATION_REQUEST_MESSAGE: "Location Request Message",
  TEMPLATE: "Template Message",
  FLOW: "Flow Message",
  CTA_URL: "CTA URL Message",
  CONTACTS: "Contacts Message",
};

const PreviewNodeContainer = ({ children, node, bgColor = "#0ACD95", closeNode }) => {
  const nodeItem = OPERATIONS_LIST.find((item) => item?.key === node?.type) || ACTIONS_LIST.find((item) => item?.key === node?.type);
  const isOperation = OPERATIONS_LIST.map((item) => item?.key).includes(node?.type);
  return (
    <div
      className="w-fit h-full rounded-2xl overflow-hidden select-none z-[1] pointer-events-auto bg-white shadow-[0px_3.09px_23.21px_0px_#2D30361A]"
      style={{ background: isOperation ? undefined : bgColor }}
    >
      <div
        className={`w-full h-[2.5rem] flex items-center justify-between gap-[7px] p-3 text-white relative group ${isOperation ? 'rounded-b-md' : ''}`}
        style={{ background: isOperation ? nodeItem?.headerBgColor : bgColor }}
      >
        {isOperation && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              closeNode(node?.uniq_id);
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors duration-200 group-hover:opacity-100"
            aria-label="Close preview"
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
        <div className="w-full h-5 flex items-center gap-1.5">
          {node?.is_trigger ? (
            node?.trigger_type === "CAMP_QR_URL" ? (
              <QRCode />
            ) : node?.trigger_type === "CAMP_WAPP_BCAST" ? (
              <Broadcast
                color={"#ffffff"}
                bg={bgColor}
                width={20}
                height={20}
                strokeWidth={"1.5"}
              />
            ) : node?.trigger_type === "API_TRIGGER" ? (
              <WebhookIcon color={"#ffffff"} width={20} height={20} className="pr-5" />
            ) : node?.trigger_type === "KEYWORD_TRIGGER" ? (
              <Key color={"#ffffff"} width={20} height={20} />
            ) : node?.trigger_type === "META_AD" ? (
              <Meta />
            ) : (
              <></>
            )
          ) : (
            node?.type == "FOLLOW_UP" ? (
              <FollowUpTimer fill={"#ffffff"} width={18} height={18} />
            ) :
            node?.type == "ASSIGNEE" ? (
              <Assignee fill={"#ffffff"} width={26} height={22} className="" />
            ) : (
              <Whatsapp color={"#ffffff"} width={18} height={18} />
            )
          )}

          {node?.is_trigger ? (
            <p className="w-10/12 max-w-52 truncate !capitalize text-base weight-semibold">
              {node?.trigger_type === "CAMP_WAPP_BCAST" ? (
                <>{node?.data?.broadcast?.name || "Broadcast"}</>
              ) : node?.trigger_type === "CAMP_QR_URL" ? (
                <>QR Code Scan</>
              ) : node?.trigger_type === "API_TRIGGER" ? (
                <>API Trigger</>
              ) : node?.trigger_type === "KEYWORD_TRIGGER" ? (
                <>Keyword Trigger</>
              ) : (
                <>{node?.data?.name}</>
              )}
            </p>
          ) : (
              <p className="!capitalize text-base weight-semibold">
                {node?.label === 'Payment Captured' || node?.label === 'Payment Failed' || node?.label === 'Flow Completed' ? (
                  <>{node.label}</>
                ) : nodeItem?.headerText ? (
                  <>{nodeItem.headerText}</>
                ) : (
                  <>{nodeTypes[node?.type]}</>
                )}
            </p>
          )}
        </div>
      </div>
      <div className={`pt-0 ${(isOperation)? '' : 'p-1'}`}>{children}</div>
    </div>
  );
};

export default PreviewNodeContainer;
